import React from 'react';
import { projectsData } from "./Data";
import ProjectItems from "./ProjectItems";

const Projects = () => {
    return (
        <div className="project__container">
            {projectsData.map((item) => (
                <ProjectItems item={item} key={item.id} />
            ))}
        </div>
    );
}

export default Projects;